
import RegionHeader from "@/components/region/RegionHeader"
import RegionToolbar from "@/components/layout/navigation/RegionToolbar"
import RegionSchools from "@/components/region/RegionSchools"
import SearchTextField from "@/components/base/input/SearchTextField"

import regionMeta from "@/mixins/regionMeta"
import currentYearMixin from "@/mixins/currentYearMixin"

export default {
    meta: {
        toolbar: {
            hideSearch: true,
        },
        footer: {
            showPowered: true,
        },
    },
    components: {
        RegionToolbar,
        RegionHeader,
        RegionSchools,
        SearchTextField,
    },
    mixins: [currentYearMixin, regionMeta],
    async asyncData({ route, $axios }) {
        const response = await $axios.$get("/api/regions/" + route.params.slug)
        return {
            region: response.data,
        }
    },
    data: () => {
        return {
            region: {},
            searchInput: "",
            exampleSuggestions: ["Gymnasium", "Mittelschule"],
        }
    },
    head() {
        return {
            title: this.region.name + ": Schulen der Region",
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content:
                        this.region.name +
                        ": Überblick über die Schulen in deiner Umgebung.",
                },
                {
                    hid: "og:title",
                    name: "og:title",
                    content: this.region.name + ": Schulen der Region",
                },
                {
                    hid: "og:description",
                    name: "og:description",
                    content:
                        this.region.name +
                        ": Überblick über die Schulen in deiner Umgebung.",
                },
                ...this.getOgImage(),
            ],
        }
    },
}
